@if (isVisible()) {
  <div class="lg:z-[99] z-[9] w-full py-2 lg:px-6 px-2 text-white fixed flex justify-between items-center lg:gap-4 gap-1 bg-[--secondary-idle] border-b-4 border-[#F00F40]" id="impersonation-status">
    <span class="text-sm line-clamp-2">{{ "userImpersonationStatus.userNotice" | translate }} {{ impersonationContext()?.impersonatedCustomerName??'' }} ({{ customerId() }})</span>
    <div class="flex items-center lg:gap-3 gap-1">
      <p-button size="small" (onClick)="finishImpersonation()">{{ (isSmallScreen() ? "userImpersonationStatus.endActionLabelMobile":"userImpersonationStatus.endActionLabel") | translate }}</p-button>
      @if (heroVisible()) {
        <button
          pButton
          type="button"
          size="small"
          class="hero-close-button"
          icon="pi pi-times"
          [label]="'closeButton' | translate"
          [attr.aria-label]="'closeButton' | translate"
          (click)="toggleHeroVisible()"></button>
      }
    </div>
  </div>
}
